<div class="dialogContainer">
  <div class="header">
    <h2>CANCEL {{ entityKey.entityName }} {{ entityLines && entityLines.length > 0 ? 'LINES' : '' }}</h2>
  </div>
  <div class="content">
    <div>
      <label for="reasonInput" class="inputLabel">Cancel Reason:</label>
      <select id="reasonInput" [(ngModel)]="reasonCode" class="inputField">
        <option value="undefined" disabled>Please Select</option>
        @for (reason of reasonCodes(); track reason) {
          <option [value]="reason.code">{{ reason.description }}</option>
        }
      </select>
    </div>
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="abort()">Abort</button>
      <button class="warn-button" [disabled]="!reasonCode" matButton="elevated" (click)="proceed()">Proceed</button>
    </span>
  </div>
</div>
